import Component123 from "./pages/Component";

function App() {
  return (
    <>
      <Component123 />
    </>
  );
}

export default App;
